import { render } from "./radiobutton-subquestions.html?vue&type=template&id=6f5abbee&scoped=true&ts=true&external"
import script from "./radiobutton-subquestions.ts?vue&type=script&lang=ts&external"
export * from "./radiobutton-subquestions.ts?vue&type=script&lang=ts&external"

import "./radiobutton-subquestions.scss?vue&type=style&index=0&id=6f5abbee&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f5abbee"]])

export default __exports__